import Vue from "vue";

import App from "./App.vue";

import router from "./router";

import store from "./store";


import moment from "moment";
import momentDurationFormatSetup from "moment-duration-format";

import { BootstrapVue } from "bootstrap-vue";

import { VLazyImagePlugin } from "v-lazy-image";

import TextareaAutosize from "vue-textarea-autosize";

import VueFormWizard from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
Vue.use(VueFormWizard);

import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";

Vue.use(BootstrapVue);

Vue.use(VLazyImagePlugin);
Vue.use(TextareaAutosize);

Vue.prototype.vWindow = window;

import VueClipboard from "vue-clipboard2";
VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);

Vue.prototype.moment = moment;
Vue.prototype.momentDurationFormatSetup = momentDurationFormatSetup;

//CSS
import "./assets/css/vendor/bootstrap/bootstrap.scss";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "./assets/css/vendor/golden-ratio/gr.scss";
import "./assets/css/vendor/line-icons/scss/main.scss";
import "./assets/css/vendor/float-labels/float-labels.css";
import "./assets/css/theme.scss";
import "./assets/css/custom.scss";

//firebase
//service worker is copied in public folder of both the ui and laravel
import { initializeApp } from "firebase/app";
import { getMessaging, onMessage } from "firebase/messaging";
import icon from './assets/img/logo.png'
import Push from "push.js";

const firebaseConfig = {
  apiKey: "AIzaSyCZUNP5539j2Qd_LP-UfZYBiylBzvTF8vk",
  authDomain: "online-dawood.firebaseapp.com",
  projectId: "online-dawood",
  storageBucket: "online-dawood.appspot.com",
  messagingSenderId: "780991913176",
  appId: "1:780991913176:web:663b38db4aad3133f58bad"
};

initializeApp(firebaseConfig)
//the firebase token is retrieved in TheAppHeader.vue

//foreground message received
const messaging = getMessaging();
onMessage(messaging, (payload) => {
    Push.create(payload.notification.title, {
        body: payload.notification.body,
        icon: icon,
        timeout: 3000,
        onClick: function () {
          window.focus();
          this.close();
        },
      });
});

//config
Vue.config.productionTip = false;


//filters
Vue.filter("capitalize", function(value) {
    if (!value) return "";
    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1);
});
Vue.filter("jsonPretty", function(value) {
    return JSON.stringify(value, null, 2);
});

Vue.filter("currency", function(value) {
    if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    } else {
        return value;
    }
});

//directives
Vue.directive("uppercase", {
     update(el) {
    const sourceValue = el.value;
    const newValue = sourceValue.toUpperCase();

    if (sourceValue !== newValue) {
      el.value = newValue;
      el.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }
});

//Global Mixins
Vue.mixin({
    methods: {
        userHasPerms: function(permList, admin) {

    

            if (admin === true) {
                //admin only menu
                return this.$store.state.user.user.is_admin == 1;
            }
            
            if (permList == null || permList.length == 0) {
                return true;
            }

            let permissions = this.$store.state.user.permissions.map(
                x => x.permission
            );

            if (permList && permList.length > 0) {
                let matches = permList.filter(i => permissions.includes(i));
                return matches.length > 0;
            }

            

            return false;
        }
    }
});



new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");

// redirect if location not available
if(!("geolocation" in navigator)) {
  router.push({ path: 'no-location' })
}

navigator.geolocation.getCurrentPosition(
    () => {}, 
    () => {
        router.push({ path: 'no-location' })
    }
)

  if (!("Notification" in window)) {
    console.log("This browser does not support desktop notification");
  }

  else if (Notification.permission != "granted") {
    Notification.requestPermission().then(function (permission) {
        if (permission != "granted") {      
          router.push({ path: 'no-location' })
        }
      });
  }
